import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import PrefillReportOutputComponent from '../output/PrefillReportOutputComponent';

const PrefillReportInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-file', title: 'Prefill Report', subtitle: 'Fetch a comprehensive prefill report by name + mobile' }}
        fields={[
            { name: 'name', label: 'Full Name', icon: 'pi-user', placeholder: 'Enter full name', maxLength: 100, autoCapitalize: 'words' },
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
        ]}
        endpoint={{
            path: '/surepass/prefill/prefill-report',
            bodyMapper: (v, sid) => ({ name: v.name.trim(), mobile: v.mobile, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="prefill-report"
        submitLabel="Fetch Prefill Report"
        successSummary="Prefill report fetched"
        errorSummary="Prefill report failed"
        confirmHeader="Confirm prefill report fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={PrefillReportOutputComponent}
    />
);

export default PrefillReportInputComponent;
